import axios from "axios";
import { getCookie } from "./getCookie";
import { getApiUrl } from "./getApiUrl";

export const createApi = (path: string) => {
  const baseURL = getApiUrl();
  const token = getCookie("token");
  const instance = axios.create({
    baseURL: `${baseURL}api/${path}`,
    headers: {
      "Content-Type": "application/json",
      // Only when there is a token. The literal "Bearer undefined" that an
      // expired cookie used to produce is rejected at the load balancer with
      // an HTML 403 carrying no CORS headers, so every call surfaced as
      // "Network Error" and no handler could tell it was an auth problem.
      // Without the header the API answers a JSON 403 the app can act on.
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  return instance;
};
